// extracted by mini-css-extract-plugin
export default {"page404Container":"Page404_page404Container__lsfl2","page404__title":"Page404_page404__title__OXWY8","button":"Page404_button__yN5PB"};